import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	highlightedPageIncludeRenderedError: {
		id: 'fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError',
		defaultMessage: 'Unable to render { include }',
		description: 'Highlighted Message to display if include page already rendered',
	},
	nonhighlightedPageIncludeRenderedError: {
		id: 'fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError',
		defaultMessage: ' Already included page “{pageTitle}”, stopping.',
		description:
			'Message appears right after the highlighted message to indicate the page title that has already been rendered',
	},
});
